import React, { FC, useContext } from 'react';
import Button from '@zola/zola-ui/src/components/Button/ButtonV2';
import signupLinkCallback, {
  isRegistry,
} from 'components/common/auth/AuthModal/helpers/signupLinkCallback';

import './navLoginOrSignUp.less';
import {
  CtaType,
  trackCtaClicked,
} from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';
import type { NavLoginOrSignUpDispatchProps } from '.';
import NavContext from '../NavScrollContainer/context';

type NavLoginOrSignUpProps = NavLoginOrSignUpDispatchProps & {
  isNavV3?: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const NavLoginOrSignUp: FC<NavLoginOrSignUpProps> = ({ onShowLogin, isNavV3 = false }) => {
  const { activeLinkId } = useContext(NavContext);

  const getButtonText = () => {
    return isRegistry(activeLinkId) ? 'Start your registry' : 'Get started';
  };

  const handleClickTrack = () => {
    const ctaText = getButtonText();
    trackCtaClicked({
      business_unit: 'CORE',
      cta_type: CtaType.BUTTON,
      cta_id: 'NAV_PRE_AUTH_SIGNUP',
      position: 1,
      cta: ctaText,
    });
    if (signupLinkCallback(activeLinkId)) onShowLogin();
  };

  return (
    <>
      <Button className="nav-signup" onClick={handleClickTrack}>
        {getButtonText()}
      </Button>
    </>
  );
};

export default NavLoginOrSignUp;
